import e from "./_virtual/_axios.mjs";
import { __require as t } from "./util/buildSmartyResponse.mjs";
var s, o;
function r() {
  if (o) return s;
  o = 1;
  const r = e.default,
    {
      buildSmartyResponse: a
    } = t();
  return s = class {
    constructor(e = 1e4, t, s = !1) {
      this.axiosInstance = r.create(), this.timeout = e, this.proxyConfig = t, s && this.enableDebug();
    }
    buildRequestConfig({
      payload: e,
      parameters: t,
      headers: s,
      baseUrl: o
    }) {
      let r = {
        method: "GET",
        timeout: this.timeout,
        params: t,
        headers: s,
        baseURL: o,
        validateStatus: function (e) {
          return e < 500;
        }
      };
      return e && (r.method = "POST", r.data = e), this.proxyConfig && (r.proxy = this.proxyConfig), r;
    }
    send(e) {
      return new Promise((t, s) => {
        let o = this.buildRequestConfig(e);
        this.axiosInstance(o).then(e => {
          let o = a(e);
          o.statusCode >= 400 && s(o), t(o);
        }).catch(e => s(a(void 0, e)));
      });
    }
    enableDebug() {
      this.axiosInstance.interceptors.request.use(e => (console.log("Request:\r\n", e), console.log("\r\n*******************************************\r\n"), e)), this.axiosInstance.interceptors.response.use(e => (console.log("Response:\r\n"), console.log("Status:", e.status, e.statusText), console.log("Headers:", e.headers), console.log("Data:", e.data), e));
    }
  };
}
export { r as __require };